/* eslint-disable react/no-unknown-property */
import { useEffect, useState } from 'react'
import { BrandName } from '../../Typescript'
import ccpaIcon from '../../assets/images/logos/ccpa-icon.svg'
import './Footer.css'

const Footer = ({ brandName }: { brandName: BrandName }) => {
    const upperCaseBrand = brandName === BrandName.msnbc ? 'MSNOW' : 'CNBC'
    const [showCcpaOptOutIcon, setShowCcpaOptOutIcon] = useState(true)
    const [privacyChoiceHref, setPrivacyChoiceHref] = useState('')
    const [privacyChoiceTarget, setPrivacyChoiceTarget] = useState('')
    const [privacyChoicesLinkText, setPrivacyChoicesLinkText] = useState('Your Privacy Choices')

    const footerLinks = {
        privacy: `https://www.versantprivacy.com/privacy?intake=${upperCaseBrand}`,
        termsOfUse: 'https://www.versantmedia.com/terms',
        privacyChoices: `https://www.versantprivacy.com/privacy/notrtoo?intake=${upperCaseBrand}`,
        caNotice: `https://www.versantprivacy.com/privacy/california-consumer-privacy-act?intake=${upperCaseBrand}`,
        cookies: 'https://www.versantprivacy.com/privacy/cookies',
    }

    useEffect(() => {
        setPrivacyChoiceHref(footerLinks.privacyChoices)
        setPrivacyChoiceTarget('_blank')

        const handleOneTrustLoaded = () => {
            setPrivacyChoiceHref('#privacy-choices')
            setPrivacyChoiceTarget('')

            const country = window.Optanon?.getGeolocationData()?.country
            setShowCcpaOptOutIcon(country === 'US')

            const linkText = window.OneTrust?.GetDomainData().CookieSettingButtonText
            if (linkText) {
                setPrivacyChoicesLinkText(linkText)
            }
        }

        window.addEventListener('oneTrustLibraryLoaded', handleOneTrustLoaded)

        if (window.Optanon) {
            handleOneTrustLoaded()
        }

        return () => {
            window.removeEventListener('oneTrustLibraryLoaded', handleOneTrustLoaded)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <footer id="footer">
            <div className="footer clearfix">
                <div className="copyright">
                    <span>
                        {brandName === BrandName.msnbc
                            ? '© 2025 Versant Media, LLC'
                            : '© 2025 Versant Media, LLC. All Rights Reserved. A Versant Media Company'}
                    </span>
                </div>
                <div className="footerLinks">
                    <div>
                        <a
                            href={footerLinks.privacy}
                            title=""
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e) =>
                                window.s &&
                                window.s.trackLink(e.target, 'o', 'Footer:Privacy Policy - New')
                            }
                        >
                            Privacy Policy - New
                        </a>
                    </div>
                    <div>
                        <a
                            href={footerLinks.termsOfUse}
                            title=""
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e) =>
                                window.s &&
                                window.s.trackLink(e.target, 'o', 'Footer:CA Terms Of Service')
                            }
                        >
                            Terms Of Service
                        </a>
                    </div>
                    <div className="privacyChoicesDiv">
                        <img
                            style={{ display: showCcpaOptOutIcon ? 'block' : 'none' }}
                            src={ccpaIcon}
                            className="optOutIcon"
                            alt="opt-out"
                        />
                        <a
                            href={privacyChoiceHref}
                            className="ot-sdk-show-settings"
                            rel="noopener noreferrer"
                            target={privacyChoiceTarget}
                            onClick={(e) =>
                                window.s &&
                                window.s.trackLink(e.target, 'o', 'Footer:Your Privacy Choices')
                            }
                        >
                            {privacyChoicesLinkText}
                        </a>
                    </div>
                    <div>
                        <a
                            href={footerLinks.caNotice}
                            title=""
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e) =>
                                window.s && window.s.trackLink(e.target, 'o', 'Footer:CA Notice')
                            }
                        >
                            CA Notice
                        </a>
                    </div>
                    <div>
                        <a
                            href={footerLinks.cookies}
                            target="_blank"
                            className="adChoice"
                            rel="noreferrer"
                        >
                            <img
                                alt=""
                                id="_bapw-icon" // cspell:disable-line
                                className="adChoiceImg"
                                src="https://image.cnbcfm.com/api/v1/image/106572888-1591819082504icon1.png"
                            />
                            <span className="adChoiceSpan">AdChoice</span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
